module.exports = __webpack_public_path__ + "assets/img/s1_tab2_active.f7a3cd6d.png";